'use client';
import * as Icon from '@/ui/Icon';
import { IOrganization } from '@/types';
import { usePathname } from 'next/navigation';
import useOxenSession from '@/hooks/useOxenSession';

import NavTabs, { LinkTab } from '../NavTabs';

export type OrganizationTabType = 'repositories' | 'users' | 'settings';

const OrganizationNavTabs: React.FC<{
  organization?: IOrganization;
  activeTab: OrganizationTabType;
}> = ({ organization, activeTab }) => {
  const pathname = usePathname();
  const { authorization } = useOxenSession();

  const baseUserPath = `/${organization?.name}`;
  const repositoriesPath = baseUserPath;
  const usersPath = `/organizations/${organization?.name}/users`;
  const settingsPath = `/organizations/${organization?.name}/settings`;

  return (
    <NavTabs>
      <LinkTab href={repositoriesPath} isActive={pathname === repositoriesPath}>
        <Icon.Book />
        <span>Repositories</span>
      </LinkTab>
      {authorization.forOrganization(organization).canView() && (
        <LinkTab href={usersPath} isActive={pathname === usersPath}>
          <Icon.Users />
          <span>Users</span>
        </LinkTab>
      )}
      {authorization.forOrganization(organization).canManage() && (
        <LinkTab href={settingsPath} isActive={pathname === settingsPath}>
          <Icon.Cog />
          <span>Settings</span>
        </LinkTab>
      )}
    </NavTabs>
  );
};

export default OrganizationNavTabs;
